import { selectFields } from '#src/lib/contentful/selectors.mjs';
import Link from '#src/components/Link/index.js';

import styles from './CardCta.scss';
import { CardImage } from './CardImage';

export function CardCta({ cta, theme, isDarkBackground }) {
  const { callToAction, image } = selectFields(cta);
  const { link, label } = selectFields(callToAction);
  return (
    <div className={styles.cardCta}>
      <Link href={link} className={styles.cardCtaLink}>
        <CardImage image={image} />
        <span>{label}</span>
      </Link>
    </div>
  );
}
